/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Parameters for LiveKit oral exam presence-based unwind job.

Selects overdue pending/confirmed bookings past ``margin_hours`` after end
(no ``meetingStartedAt`` requirement on the classifier — presence comes from
the oral run). Never present → student no-show; present never committed →
university cancel; committed → skip (wrap-up).
 */
export interface MeetingsLivekitOralUnwindParams {
  marginHours?: number;
  statuses?: string[];
}
